
define('jsx!components/modal/share/share-settings',[
	"underscore",
	"react",
	"shared/client",
	"jsx!components/widgets/toggle",
], function(_, React, Client, Toggle) {
	var ____Class1=React.Component;for(var ____Class1____Key in ____Class1){if(____Class1.hasOwnProperty(____Class1____Key)){ShareSettings[____Class1____Key]=____Class1[____Class1____Key];}}var ____SuperProtoOf____Class1=____Class1===null?null:____Class1.prototype;ShareSettings.prototype=Object.create(____SuperProtoOf____Class1);ShareSettings.prototype.constructor=ShareSettings;ShareSettings.__superConstructor__=____Class1;
		function ShareSettings(props) {"use strict";
			____Class1.call(this,props);

			_.bindAll(this,
				"handleChangeOnPrivacySelector",
				"toggleCommentable",
				"toggleCopyable",
				"renderPrivacySelector",
				"renderCommentableToggle",
				"renderCopyableToggle"
			);
		}

		Object.defineProperty(ShareSettings.prototype,"handleChangeOnPrivacySelector",{writable:true,configurable:true,value:function(e) {"use strict";
			var privacyLevel = $(e.currentTarget).val();
			var buncee = window.appData.buncee.data;
			this.props.actions.setPrivacy(buncee.guid, privacyLevel);

			/*
			 * If set to public-curatable, then we must alert the user that the buncee
			 * might be selected.
			 */
			if (privacyLevel == "public-curatable") {
				this.props.actions.toast(".buncee-modal-action", "Awesome! We may select your Buncee for the staff picks page.");
			}
		}});

		Object.defineProperty(ShareSettings.prototype,"toggleCommentable",{writable:true,configurable:true,value:function() {"use strict";
			var buncee = window.appData.buncee.data;
			this.props.actions.setCommentable(buncee.guid, !buncee.commentable);
		}});

		Object.defineProperty(ShareSettings.prototype,"toggleCopyable",{writable:true,configurable:true,value:function() {"use strict";
			var buncee = window.appData.buncee.data;
			this.props.actions.setCopyable(buncee.guid, !buncee.copyable);
		}});

		Object.defineProperty(ShareSettings.prototype,"renderPrivacySelector",{writable:true,configurable:true,value:function() {"use strict";
			var buncee = window.appData.buncee.data;

			var defaultPrivacyValue = buncee.privacy_level;
			if (buncee.is_curatable && Client.isPublic()) {
				defaultPrivacyValue = "public-curatable";
			}	

			return React.createElement("div", {className: "form-group"}, 
				React.createElement("label", {htmlFor: "privacySelector", className: "col-sm-3 col-md-3 col-lg-3 control-label"}, "Who Can View"), 
				React.createElement("div", {className: "col-sm-9 col-md-9 col-lg-9"}, 
					React.createElement("select", {id: "privacySelector", name: "privacy", className: "form-control", onChange: this.handleChangeOnPrivacySelector, defaultValue: defaultPrivacyValue}, 
						React.createElement("option", {value: "private"}, "Only Me"), 
						 !Client.isPublic() ? React.createElement("option", {value: "domain"}, "Anyone part of ",  window.appData.client.name) : null, 
						React.createElement("option", {value: "public"}, "Anyone with the link"), 
						 Client.isPublic() ? React.createElement("option", {value: "public-curatable"}, "Anyone") : null
					)
				)
			);
		}});

		Object.defineProperty(ShareSettings.prototype,"renderCommentableToggle",{writable:true,configurable:true,value:function() {"use strict";
			var buncee = window.appData.buncee.data;

			return React.createElement("div", {className: "form-group"}, 
				React.createElement("label", {htmlFor: "toggleCommentable", className: "col-sm-3 col-md-3 col-lg-3 control-label"}, "Commentable"), 
				React.createElement("div", {className: "col-sm-9 col-md-9 col-lg-9"}, 
					React.createElement(Toggle, {
						classes: "pull-left", 
						toggleStatus: this.toggleCommentable, 
						status: buncee.commentable})
				)
			);
		}});

		Object.defineProperty(ShareSettings.prototype,"renderCopyableToggle",{writable:true,configurable:true,value:function() {"use strict";
			var buncee = window.appData.buncee.data;

			return React.createElement("div", {className: "form-group"}, 
				React.createElement("label", {htmlFor: "toggleCopyable", className: "col-sm-3 col-md-3 col-lg-3 control-label"}, "Copyable"), 
				React.createElement("div", {className: "col-sm-9 col-md-9 col-lg-9"}, 
					React.createElement(Toggle, {
						classes: ["pull-left"], 
						toggleStatus: this.toggleCopyable, 
						status: buncee.copyable})
				)
			);
		}});

		Object.defineProperty(ShareSettings.prototype,"render",{writable:true,configurable:true,value:function() {"use strict";
			/**
			 * On the public tenant, an additional pseudo-privacy level setting
			 * is included. This "Anyone" setting is equivalent to "Anyone with the link",
			 * but it also marks the buncee as curatable for selection to Staff Picks.
			 */

			return React.createElement("div", null, 
				React.createElement("div", {className: "buncee-modal-description", style: { marginTop: "20px"}}), 
				React.createElement("div", {className: "form-horizontal", style: {marginTop: "10px", marginBottom: "30px"}}, 
					this.renderPrivacySelector(), 
					this.renderCommentableToggle(), 
					this.renderCopyableToggle()
				)
			)
		}});
	

	return ShareSettings;
});
